import React, { useState, useEffect } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { useParams, useHistory } from 'react-router-dom';
import { useAuth } from '../common/AuthProvider';
import { fetchData } from '../common/Api';
import ProjectsTab from './ProjectsTab';
import TeamsTab from './TeamsTab';
import ShirtsTab from './ShirtsTab';
import TeamsProjectsTab from './TeamsProjectsTab';
import AllocationTab from './AllocationTab';
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { IconButton } from "@mui/material";


const Space = () => {

  const history = useHistory();
  const { id } = useParams();
  const { isAuthenticated } = useAuth();
  const [data, setData] = useState({});
  const [error, setError] = useState(null);
  const [key, setKey] = useState('projects');
  const [expanded, setExpanded] = useState(true);

  useEffect(() => {
    const getData = async () => {
      try {
            await fetchData(
            `/api/v1/spaces/${id}`
            ).then(response => setData(response.data));
        } catch (error) {
            setError(error);
        }
    }
    getData();
  }, []);

  useEffect(()=> {
    if (error) {
        console.log(`Error loading space :: ${error.message}`);
        if (error.status === 401){
            history.push('/login');
        } else if (error.status === 404){
            history.push('/spaces');
        }
        setError(null);
    }
  }, [error]);

  return (
    <div className='page-container'>
    {
      isAuthenticated ? <div>
      <div className='space-header-container'>
        <div className='space-header'>
        <h2>{data.name}</h2>
        <IconButton onClick={() => setExpanded(!expanded)}>
          {expanded ? <ExpandLess /> : <ExpandMore />}
        </IconButton> 
        </div>
        {expanded && (
          <div>
            <p>{data.description}</p>
          </div>
        )}
      </div>

      <Tabs activeKey={key} onSelect={(k) => setKey(k)}>
        <Tab eventKey="projects" title="Projects"><ProjectsTab id={id}/></Tab>
        <Tab eventKey="teams" title="Teams"><TeamsTab id={id}/></Tab>
        <Tab eventKey="shirts" title="Shirts"><ShirtsTab id={id} /></Tab>
        <Tab eventKey="projectsteams" title="Planning"><TeamsProjectsTab id={id}/></Tab>
        <Tab eventKey="allocation" title="Allocation"><AllocationTab id={id}/></Tab>
      </Tabs>

      </div> : null
    }
    </div>
  );
};

export default Space;

